// @react/hooks/useTaskCustomField.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { taskCustomFieldStore } from '@core/stores';

/**
 * React hook for CustomFieldDefinition operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTaskCustomField } from '@react/hooks';
 *
 * const CustomFieldDefinitionList = observer(() => {
 *   const store = useTaskCustomField();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTaskCustomField() {
  return taskCustomFieldStore;
}
